import {
  HiHome,
  HiCalendar,
  HiCurrencyDollar,
  HiClipboardList,
  HiChatAlt2,
  HiChartBar,
  HiDocumentText,
  HiUserGroup,
  HiCheckCircle,
  HiShieldCheck,
  HiBookOpen
} from 'react-icons/hi';

const navItems = [
  { to: '/dashboard', icon: HiHome, label: 'Dashboard', mobileLabel: 'Home' },
  { to: '/calendar', icon: HiCalendar, label: 'Calendar' },
  { to: '/activities', icon: HiClipboardList, label: 'Activities', mobileTab: 'more' },
  { to: '/chores', icon: HiCheckCircle, label: 'Chores', mobileTab: 'more' },
  { to: '/rules', icon: HiShieldCheck, label: 'Household Rules', mobileTab: 'more' },
  { to: '/expenses', icon: HiCurrencyDollar, label: 'Expenses' },
  { to: '/insights', icon: HiChartBar, label: 'Insights', mobileTab: 'more' },
  { to: '/messages', icon: HiChatAlt2, label: 'Messages' },
  { to: '/documents', icon: HiDocumentText, label: 'Documents', mobileLabel: 'Docs', mobileTab: 'more' },
  { to: '/settings', icon: HiUserGroup, label: 'Family Settings', mobileLabel: 'Settings', mobileTab: 'more' },
  { to: '/blog', icon: HiBookOpen, label: 'Blog', mobileTab: 'more', external: true },
];

export default navItems;
